<template>
  <div
    class="BulkOrderbysea"
    style="
      background: #ffffff;
      box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
      border-radius: 10px;
    "
  >
    <h4>FBA订单</h4>
    <el-form
      ref="OrderQueryConditions"
      :label-position="labelPosition"
      :model="OrderQueryConditions"
      label-width="70px"
    >
      <el-form-item label="运单号">
        <el-input
          style="width:260px"
          v-model.trim="OrderQueryConditions.OrderCode"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="PO号">
        <el-input
        style="width:260px"
          v-model.trim="OrderQueryConditions.pro"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select style="width:260px" v-model="OrderQueryConditions.status" placeholder="请选择订单状态">
          <el-option v-for="(item, index) of stateList" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入仓仓库">
        <el-cascader
          clearable
          filterable
          style="width:260px"
          placeholder="请选择入仓仓库"
          v-model="thatALLcklist"
          :options="FBAfromCk"
          :props="FBAdataprops"
          ref="changefromFABck"
          @change="changefromFABck(thatALLcklist)"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item  label="目的仓库">
        <el-cascader
          clearable
          filterable
          placeholder="请选择目的仓库"
          style="width:260px"
          ref="changetoFABck"
          v-model="thatFBAcklist"
          :options="FBAtoCk"
          :props="toFBAdataprops"
          :filter-method="handleFilter"
          @change="changetoFABck(thatFBAcklist)"
        >
          <template slot-scope="{ node, data }">
            <span>{{ data.namec }}</span>
            <span v-if="!node.isLeaf"></span>
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item  label="入仓时间" >
        <el-date-picker
          style="width: 260px"
          v-model="OrderQueryConditions.inHouseData"
          type="daterange"
          value-format="yyyy-MM-dd"
          clearable
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item  label="委托日期">
        <el-date-picker
          style="width: 260px"
          v-model="OrderQueryConditions.EntrustmentData"
          type="daterange"
          clearable
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" @keyup.enter="enterSearch">查询</el-button
      >
      <el-button type="primary" style="margin-left: 0px;background: white;border: 1px solid #FF4D01;color: #FF4D01;" @click="handleClear"
        >重置</el-button
      >
      </el-form-item>

    </el-form>
    <el-table
      border
      align="center"
      :data="tableData"
      max-height="580"
      tooltip-effect="dark"
      :header-cell-style="{ background: '#F3F3F3' }"
      ref="multipleTable"
      style="width: 95% !important; margin-left: 32px"
    >
      <!-- <el-table-column type="selection" label="全选" min-width="5%"></el-table-column> -->
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->

      <el-table-column
        type="index"
        label="序号"
        width="60px"
        min-width="8%"
      ></el-table-column>
      <el-table-column
        prop="nos"
        label="运单号"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="pro"
        label="PO号"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="thirdNos"
        label="转单号"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="warehousename"
        label="入仓仓库"
        min-width="10%"
      ></el-table-column>
       <el-table-column
        prop="inwarehouseTime"
        label="入仓时间"
        min-width="10%"
      ></el-table-column>
       <el-table-column
        prop="inputtime"
        label="委托时间"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="recgoodscountry"
        label="目的国家"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="recgoodsname"
        label="目的仓库"
        min-width="10%"
      ></el-table-column>
      <el-table-column
        prop="stateCode"
        label="订单状态"
        min-width="10%"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="scope.row.stateCode == 'S'">待审核</div>
            <div v-else-if="scope.row.stateCode == 'A'">已入仓</div>
            <div v-else-if="scope.row.stateCode == 'F'">已作废</div>
            <div v-else-if="scope.row.stateCode == 'I'">待入仓</div>
            <div v-else>已出仓</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="货物信息" min-width="15%">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.beforeGoodsList.length"
            trigger="hover"
            placement="top"
          >
            <div style="text-align: center">
              <div
                v-for="(item, index) in scope.row.beforeGoodsList"
                :key="index"
              >
                {{ item.goodstype }}* {{ item.number }} {{ item.cbm }}CBM
                {{ item.weight }}KG
              </div>
            </div>
            <div slot="reference" class="name-wrapper">
              {{ scope.row.beforeGoodsList[0].goodstype }}*
              {{ scope.row.beforeGoodsList[0].number }}
              {{ scope.row.beforeGoodsList[0].cbm }}CBM
              {{ scope.row.beforeGoodsList[0].weight }}KG
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="" label="入仓信息" min-width="15%">
        <template slot-scope="scope">
          <el-popover
            v-if="scope.row.goodsList.length"
            trigger="hover"
            placement="top"
          >
            <div style="text-align: center">
              <div v-for="(item, index) in scope.row.goodsList" :key="index">
                {{ item.goodstype }}* {{ item.number }} {{ item.cbm }}CBM
                {{ item.weight }}KG
              </div>
            </div>
            <div slot="reference" class="name-wrapper">
              {{ scope.row.goodsList[0].goodstype }}*
              {{ scope.row.goodsList[0].number }}
              {{ scope.row.goodsList[0].cbm }}CBM
              {{ scope.row.goodsList[0].weight }}KG
            </div>
          </el-popover>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="预估费用" min-width="10%">
        <template slot-scope="scope">
          {{
            scope.row.costbeforeinfo.amount1
              ? scope.row.costbeforeinfo.amount1
              : 0.0
          }}
        </template>
      </el-table-column>
      <el-table-column prop="" label="实际费用" min-width="7%">
        <template slot-scope="scope">
          {{
            scope.row.costinfo.amount2 != "0.00"
              ? scope.row.costinfo.amount2
              : "-"
          }}
        </template>
      </el-table-column>

      <!-- <el-table-column prop="job_status" label="状态" min-width="10%"></el-table-column> -->
      <el-table-column prop="operation" label="" min-width="13%">
        <template slot-scope="scope">
          <el-dropdown
            @command="
              (command) => {
                handleCommand(command, scope.row, scope);
              }
            "
          >
            <span style="cursor: pointer" class="el-dropdown-link">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="orderdetails"
                ><span>查看详情</span></el-dropdown-item
              >
              <el-dropdown-item command="FbaChangebill"
                ><span v-if="scope.row.stateCode == 'S'"
                  >修改订单</span
                ></el-dropdown-item
              >
              <el-dropdown-item command="downLoadLabel"
                ><span
                  v-if="!scope.row.isFastOrder || scope.row.attachmentUrl != ''"
                  >下载标签</span
                ></el-dropdown-item
              >
              <el-dropdown-item
                command="disableOrder"
                v-if="scope.row.state == 1"
                ><span>作废</span></el-dropdown-item
              >
              <el-dropdown-item
                v-if="
                  scope.row.isFastOrder == true &&
                  (scope.row.stateCode == 'I' || scope.row.stateCode == 'S')
                "
                command="reUpdateFile"
              >
                <span>上传装箱单</span>
              </el-dropdown-item>

              <el-dropdown-item
                v-if="
                  scope.row.isFastOrder == true &&
                  scope.row.attachmentUrl != null &&
                  scope.row.stateCode !== 'S' &&
                  scope.row.stateCode !== 'I'
                "
                command="downUpdateFile"
                ><span>下载装箱单</span></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button @click="orderdetails(scope)" type="text" size="small"
                >查看详情</el-button
              > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
      <el-tab-pane
        :label="item.staus_desc"
        :name="item.order_status"
        v-for="(item, key) in tabsList"
        :key="key"
      >
      </el-tab-pane>
    </el-tabs> -->
    <div style="">
      <el-pagination
        style="margin: 20px; float: right;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="curPageL"
        :pager-count="5"
        :page-sizes="[10, 20, 30, 40 ,50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 上传装箱清单 -->
    <el-dialog
      title="上传装箱单"
      :visible.sync="excelVisible"
      width="760px"
      :before-close="handleCloseDetails"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="helper" style="margin-top: -10px">
        <p>下载产品装箱单模板，并填写后上传</p>

        <!-- 12位 -->
        <el-upload
          style=" margin-top: 20px;"
          :show-file-list="false"
          :on-error="handleError"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          :http-request="uploadSectionFile"
          class="upload-demo"
          drag
          action=""
          multiple
          v-if="excelVisibleSync"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">仅限xls和xlsx文件</div>
        </el-upload>
      </div>

      <div
        class="center-box"
        style="text-align: center; margin-top: -10px"
        v-if="isReupdateFile"
      >
        <!-- <p> -->
          <div class="tagBox">{{ attachmentName }}</div>
        <!-- </p> -->
        <br />
        <p
          @click="isreUpdateFileBtn"
          style="color: #FF4D01; cursor: pointer; font-size: 16px;margin-left:10px"
        >
          重新上传
        </p>
      </div>

      <!-- <div class="goodsInfo">
        <p>
          运单号：<span>{{ recgoodsnos || "" }}</span>
        </p>
        <p>
          自有单号：<span>{{ customerOrderNos || "" }}</span>
        </p>
        <p>
          装箱单发票：<span>{{ attachmentName || "" }}</span>
        </p>
      </div> -->

      <span slot="footer" class="dialog-footer">
        <el-button type="success" size="mini" @click="Getdown()"
          >下载模板</el-button
        >
        <el-button
          style=" background: #fff; color: #000"
          size="mini"
          @click="handleCloseDetails"
          >取消</el-button
        >
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%"
        >
          <el-table-column align="center" width="50" type="index" label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            prop="order"
            label="错误行"
          >
          </el-table-column>
          <el-table-column label="错误描述">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "BulkOrderbysea",
  data() {
    return {
      stateList: [{
        label: "全部",
        value: ""
      },{
        label: "待审核",
        value: "S"
      }, {
        label: "已入仓",
        value: "A"
      }, {
        label: "已作废",
        value: "F"
      }, {
        label: "待入仓",
        value: "I"
      }, {
        label: "已出仓",
        value: "O"
      }], // 订单状态
      thatFBAcklist: [],
      FBAdataprops: {
        //定义 联级选择器的国家和区域获取name
        label: "namec",
        value: "id",
        children: "datWarehouseDTOList",
      },
      toFBAdataprops: {
        label: "namec",
        value: "id",
        children: "children",
      },
      thatALLcklist: [], //入仓仓库
      FBAfromCk: [],
      FBAtoCk: [],
      total: 0, //总条数
      pagesize: 10, //每页显示条数
      prefix: "",
      labelPosition: "left",
      activeName: "Z",
      tabsList: [],

      OrderQueryConditions: {
        //表单
        OrderCode: "", //运单号
        pro: "", //PO号
        InwareHouse: "", //入仓仓库
        DestinationCountry: "", //目的国家
        DistributionArea: "", //配送区域
        EntrustmentData: [], //委托日期
        inHouseData: [], //入仓时间
        status: "", // 订单状态
      },
      tableData: [],
      customerid: "", //运单号
      typeCode: "Z", //查询类型
      curPageL: 1,
      warehouseList: [], //仓库列表
      territoryList: [], //目的国家id列表
      distributionList: [], //配送目的列表
      excelVisible: false,
      recgoodsnos: "",
      resgoodsno: "",
      customerOrderNos: "",
      excelVisibleSync: false,
      fileName: "",
      fileUrlList: "",
      fileSize: "",
      orderNo: "",
      isUpdateFileBox: false,
      excelVisibleUpadte: false,
      isReupdateFile: true,
      errorLabel: [],
      attachmentName: "",
    };
  },
  watch: {},
  methods: {
    // 过滤筛选
    handleFilter(node, val){
      if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
        return true
      }
    },
    // 作废订单
    handleCommand(command, item, obj) {
      // console.log("item: ", item);
      if (command == "orderdetails") {
        this.orderdetails(obj);
      }
      if (command == "downLoadLabel") {
        this.downLoadLabel(item);
      }
      if (command == "disableOrder") {
        this.disableOrder(item);
      }
      if (command == "FbaChangebill") {
        if (item.isFastOrder) {
          this.$router.push({
            name: "newBillCargoChang",
            query: { itemWrap: item },
          });
        } else {
          this.$router.push({
            name: "FbaChangebill",
            query: { itemWrap: item },
          });
        }
      }
      if (command == "reUpdateFile") {
        this.reUpdateFile(item);
      }

      if (command == "downUpdateFile") {
        this.downUpdateFile(item);
      }
    },
    // 校验原因必填
    disableOrder(item) {
      // console.log(item);

      let validator = (v) => (v ? true : false);
      this.$prompt("请输入作废原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: validator,
        inputErrorMessage: "必填项",
      })
        .then(({ value }) => {
          this.axios
            .get(`/busFbx/invalidFbxOrder/${item.nos}/${value}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.info("作废成功");
                this.onSubmit(); //重新刷新获取列表
              } else {
                this.$message.info(res.data.message);
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    // 删除订单
    deleteOrder(item) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .get(`/busFbx/deleteFbxInvalidOrder/${item.nos}`)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.info("删除成功");
              } else {
                this.$message.info(res.data.message);
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    // 下载标签
    downLoadLabel(row) {
      this.axios
        .get(`/busFbx/downFBXOrderLabel/${row.nos}`)
        .then((res) => {
          if (res.data.code == 200) {
            let a = document.createElement("a");
            a.setAttribute("href", res.data.data);
            a.setAttribute("target", "_blank");
            a.click();
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    changefromFABck(list) {
      this.OrderQueryConditions.InwareHouse = list[1];
    },
    changetoFABck(list) {
      this.OrderQueryConditions.DestinationCountry = list[1];
    },
    //获取fba仓库
    getFBAtoCk() {
      this.axios
        .get("/warehouse/getFBAWarehouseList")
        .then((res) => {
          this.FBAtoCk = res.data.datas;
        })
        .catch((res) => {});
    },
    //获取fba起运地仓库
    getFBAfromCk() {
      this.axios
        .get("/warehouse/getAllWarehouseList")
        .then((res) => {
          this.FBAfromCk = res.data.datas;
        })
        .catch((res) => {});
    },
    //查看详情点击
    orderdetails(data) {
      if (data.row.isFastOrder) {
        this.$router.push({
          name: "FbaOrderDetails",
          query: {
            state: data.row.state,
            nos: data.row.nos,
            isFastOrder: true,
            thirdNos: data.row.thirdNos,
          },
        });
      } else {
        this.$router.push({
          name: "FbaOrderDetails",
          query: {
            state: data.row.state,
            nos: data.row.nos,
            isFastOrder: false,
            thirdNos: data.row.thirdNos,
          },
        });
      }
    },
    //点击查询方法
    onSubmit() {
      this.curPageL = 1;
      this.getAllOrder();
    },
    //tabs标签切换
    handleClick(activeName) {
      this.typeCode = activeName;
      this.getAllOrder(); //切换tabs
    },
    //分页每页多少条
    handleSizeChange(val) {
      this.pagesize = val;

      this.getAllOrder();
    },
    //分页当前页
    handleCurrentChange(val) {
      this.curPageL = val;

      this.getAllOrder();
    },
    //仓库id获取
    warehouse() {
      this.axios
        .get("/warehouse/warehouseListAll")
        .then((response) => {
          this.warehouseList = response.data.datas;
          let newda = {
            namec: "全部",
            id: "",
          };
          this.warehouseList.splice(0, 0, newda);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //目的国家以及配送区域的id获取
    territory() {
      this.axios
        .get("/filedata/filedataListAll")
        .then((response) => {
          this.territoryList = response.data.datas;
          this.distributionList = this.territoryList[0].children;
          // console.log(this.distributionList);
          let newda = {
            namec: "全部",
            id: "",
          };
          this.territoryList.splice(0, 0, newda);
          this.distributionList.splice(0, 0, newda);
          this.OrderQueryConditions.DistributionArea =
            this.distributionList[0].namec;
          // console.log(this.OrderQueryConditions.DistributionArea);//
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //切换目的国家，配送区域二级联动
    changMC(item) {
      // console.log(item);
      for (var i = 0; i < this.territoryList.length; i++) {
        if (this.territoryList[i].id == item) {
          this.distributionList = this.territoryList[i].children;
          this.OrderQueryConditions.DistributionArea =
            this.territoryList[i].children[0].namec;
        }
      }
      let newda = {
        namec: "全部",
      };
      this.distributionList.splice(0, 0, newda);
      this.OrderQueryConditions.DistributionArea =
        this.distributionList[0].namec;
    },
    //获取全部订单
    getAllOrder() {
       if(!localStorage.getItem("Authorization")){
        return
      }
      if (this.OrderQueryConditions.DistributionArea == "全部") {
        this.OrderQueryConditions.DistributionArea = "";
      }
      if (this.OrderQueryConditions.EntrustmentData == null) {
        this.OrderQueryConditions.EntrustmentData = ["", ""];
      }
      if (this.OrderQueryConditions.EntrustmentData == null) {
        this.OrderQueryConditions.EntrustmentData = [];
      }
      if (this.OrderQueryConditions.inHouseData == null) {
        this.OrderQueryConditions.inHouseData = [];
      }
      // console.log("==",this.OrderQueryConditions.DestinationCountry)
      let data = {
        beginTime: this.OrderQueryConditions.inHouseData[0] || "", //入仓开始时间
        endTime: this.OrderQueryConditions.inHouseData[1] || "", //入仓结束时间
        towarehouseid: this.OrderQueryConditions.DestinationCountry, //国家id
        curPage: this.curPageL, //当前页，默认1
        customerid: this.customerid, //客户id
        language: "CN",
        nos: this.OrderQueryConditions.OrderCode, //运单号
        pro: this.OrderQueryConditions.pro, //运单号
        pageSize: this.pagesize, //每页数量，默认20
        type: this.typeCode, //运单状态类型
        warehouseid: this.OrderQueryConditions.InwareHouse, //仓库id
        inputTime: this.OrderQueryConditions.EntrustmentData[0] || "", //委托日期
        endputTime: this.OrderQueryConditions.EntrustmentData[1] || "",
        stateCode: this.OrderQueryConditions.status, // 订单状态
      };
      // console.log(data);
      let that = this;
      that.axios
        .post("/busFbx/getFbxJobsHistoryWebList", data)
        .then((res) => {
          if (res.data.code == 200 && res.data.data.orderList.length) {
            this.tableData = res.data.data.orderList;
          } else {
            this.tableData = [];
            this.$message("没有相关信息...");
          }
          that.total = Number(res.data.data.totalCounts);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //获取个人表头信息
    getPansonageOrder() {
      let data = {
        customerid: this.customerid,
        jobtype: "C",
        language: "CN",
      };
      this.axios
        .get("/busFbx/getFBXJobStatusCount/" + this.customerid)
        .then((response) => {
          let datas = response.data.data.statusList;

          this.tabsList = [];
          for (var i = 0; i < datas.length; i++) {
            this.tabsList.push(datas[i]);
            this.tabsList[i].staus_desc =
              datas[i].staus_desc + "(" + datas[i].counts + ")";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //下载模板
    Getdown() {
      //下载模板
      this.axios
        .get(`/busFbx/downFBXBoxGoodsTemplate`, {
          responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
        })
        .then((res) => {
          if (res.status) {
            let a = document.createElement("a");
            let blob = new Blob([res.data]);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", "导入模板V2.0.xls");
            a.click();
            URL.revokeObjectURL(objectUrl); // 释放内存
          } else {
          }
        })
        .catch((res) => {});
    },
    // 点击上传
    reUpdateFile(item) {
      this.excelVisible = true;
      // this.isReupdateFile = true;
      this.recgoodsnos = item.nos;
      this.orderNo = item.nos;
      this.fileUrlList = item.attachmentUrl;
      this.attachmentName = item.attachmentName;
      this.customerOrderNos = item.customerOrderNos;
      // if (this.attachmentName == "" || this.attachmentName == null) {
      //   this.isReupdateFile = false;
      //   this.isUpdateFileBox = true;
      // }

      if (this.attachmentName == "" || this.attachmentName == null) {
        this.isReupdateFile = false;
        this.excelVisibleSync = true;
      } else {
        this.isReupdateFile = true;
        this.excelVisibleSync = false;
      }
    },

    //取消
    excelVisiblefalse() {
      this.excelVisible = false;
      this.excelVisibleSync = false;
      this.isUpdateFileBox = false;
      this.excelVisibleUpadte = false;
    },

    // 点击显示上传
    fileUpdate() {
      this.isUpdateFileBox = true;
    },
    //失败时的方法
    handleError(err) {
      this.$message.info(err.data);
    },
    //成功时的方法
    handleSuccess(response) {
      if (response.isSuccess) {
        this.$message.success(response.error);
        // this.getListByParam();
        return;
      }
      this.$message.info(response.error);
    },
    // 上传前
    handleBeforeUpload(file) {
      // 校验
      let legalName = ["xlsx", "xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
      } else {
        this.$message.info("文件格式不对，仅限xls和xlsx");
        return false;
      }
    },
    //上传
    uploadSectionFile(params) {
      // let boxNoType = 1;
      let form = new FormData();
      form.append("file", params.file);
      // form.append("boxNoType", boxNoType);
      form.append("orderNo", this.orderNo);
      this.axios
        .post(`/busFbx/reUploadOrderAttachment`, form)
        .then((res) => {
          if (res.data.code == 200) {
            this.excelVisibleSync = false;
            this.isUpdateFileBox = false;
            this.isReupdateFile = true;
            this.fileName = res.data.data.fileName;
            this.fileUrlList = res.data.data.fileUrl;
            this.fileSize = res.data.data.fileSize;
            this.$message.info(res.data.message);
            this.attachmentName = res.data.data.fileName;
            this.errorLabel = [];
            // this.ruleform.formLIst = res.data.data;
            this.getAllOrder();
          } else {
            this.$message.info(res.data.message);
          }

          if (res.data.code == -1) {
            this.errorLabel = res.data.data;
            this.$message.info(res.data.data);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    // 12重新上传
    isreUpdateFileBtn() {
      this.isReupdateFile = false;
      this.excelVisibleSync = true;
      // this.fileSize = "";
      // this.fileName = "";
      // this.fileUrl = "";
      this.isUpdateFileBox = true;
    },
    // // 19重新上传
    // reUpdateFileBtn() {
    //   this.excelVisibleUpadte = true;
    //   this.fileSize = "";
    //   this.fileName = "";
    //   this.fileUrl = "";
    // },

    // 打开12位上传文件
    excelVisibleBtn() {
      this.excelVisibleSync = true;
      this.errorLabel = [];
      this.excelVisibleUpadte = false;
      this.isReupdateFile = false;
    },

    // 打开19位
    // excelVisibleUpadteBtn() {
    //   this.excelVisibleUpadte = true;
    //   this.errorLabel = [];
    //   this.excelVisibleSync = false;
    //   this.isReupdateFile = false;
    // },

    //19失败时的方法
    // handleErrorUpdate(err) {
    //   this.$message.info(err.data);
    // },
    // //19成功时的方法
    // handleSuccessUpdate(response) {
    //   if (response.isSuccess) {
    //     this.$message.success(response.error);
    //     // this.getListByParam();
    //     return;
    //   }
    //   this.$message.info(response.error);
    // },
    // // 19上传前
    // handleBeforeUploadXls(file) {
    //   // 校验
    //   let legalName = ["xlsx", "xls"];
    //   // 拿到后缀名
    //   let name = file.name.substring(
    //     file.name.lastIndexOf(".") + 1,
    //     file.name.length
    //   );
    //   if (legalName.includes(name)) {
    //     // console.log(legalName.includes(name));
    //   } else {
    //     this.$message.info("文件格式不对，仅限后缀xls文件");
    //     return false;
    //   }
    // },

    // //上传 19
    // uploadSectionFileUpdate(params) {
    //   let boxNoType = 2;
    //   let form = new FormData();
    //   form.append("file", params.file);
    //   form.append("boxNoType", boxNoType);
    //   form.append("orderNo", this.orderNo);
    //   this.axios
    //     .post(`/busFbx/reUploadOrderAttachment`, form)
    //     .then((res) => {
    //       if (res.data.code == 200) {
    //         this.excelVisibleUpadte = false;
    //         this.isUpdateFileBox = false;
    //         this.isReupdateFile = true;
    //         this.fileName = res.data.data.fileName;
    //         this.fileUrl = res.data.data.fileUrl;
    //         this.fileSize = res.data.data.fileSize;
    //         this.$message.info(res.data.message);
    //         this.attachmentName = res.data.data.fileName;

    //         this.errorLabel = [];
    //         this.getAllOrder();
    //       }
    //       if (res.data.code == -1) {
    //         this.errorLabel = res.data.data;
    //         this.$message.info(res.data.message);
    //       }
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },
    handleCloseDetails() {
      this.excelVisible = false;
      this.excelVisibleSync = false;
      this.isUpdateFileBox = false;
      this.excelVisibleUpadte = false;
      this.errorLabel = [];
    },

    // 下载装箱清单
    downUpdateFile(item) {
      this.download(item.attachmentUrl, "test");
    },
    download(href, name) {
      let eleLink = document.createElement("a");
      eleLink.download = name;
      eleLink.href = href;
      eleLink.click();
      eleLink.remove();
    },
    // enter回车搜索
    enterSearch(){
      document.onkeydown = e => {
        if(e.keyCode == 13){
          this.onSubmit()
        }
      }
    },
    // 清空
    handleClear(){
       this.OrderQueryConditions = {
        //表单
        OrderCode: "", //运单号
        pro: "", //PO号
        InwareHouse: "", //入仓仓库
        DestinationCountry: "", //目的国家
        DistributionArea: "", //配送区域
        EntrustmentData: [], //委托日期
        inHouseData: [], //入仓时间
      },
      this.onSubmit()
    }
  },
  created() {
    let publics = this.sessionGetUserInfo();
    this.customerid = publics.customerid;
    this.enterSearch()
  },
  mounted() {
    this.getAllOrder();
    this.warehouse();
    this.territory();
    this.getPansonageOrder();
    this.getFBAfromCk();
    this.getFBAtoCk();
  },
};
</script>
<style scoped>
.goodsInfo {
  width: 400px;
  /* margin-left: 40%; */
  font-size: 16px;
  line-height: 30px;
  margin-left: 248px;
}

.el-table th.gutter {
  display: table-cell !important;
}
.BulkOrderbysea {
  width: 100%;
  height: calc(100% - 30px);
  box-sizing: border-box;
  overflow: hidden;
}
.BulkOrderbysea h4 {
  width: 100%;
  height: 24px;
  padding-top: 30px;
  padding-left: 31px;
  font-size: 24px;
  font-family: "PingFang-SC-Bold";
  color: #343434;
}
.BulkOrderbysea footer {
  width: 100%;
  height: 35px;
  margin-top: 10px;
  position: relative;
  box-sizing: border-box;
}
/* footer .el-pagination{
  position: absolute;
  right: 50px;
  width: 620px;
  box-sizing: border-box;
} */

.el-pagination >>> .el-pagination__total {
 line-height: 36px !important;
}

.BulkOrderbysea .el-form {
  margin-top: 20px;
  margin-left: 31px;
}
.BulkOrderbysea .el-form .el-input {
  width: 68%;
  height: 38px;
  line-height: 38px;
  background: #ffffff;
  border-color: #e7e7e7;
  border-radius: 5px;
}
.BulkOrderbysea .el-form .el-input--suffix {
  width: 100%;
}

.BulkOrderbysea .el-select {
  width: 68%;
}
.BulkOrderbysea .el-date-editor--daterange.el-input,
.BulkOrderbysea .el-date-editor--daterange.el-input__inner,
.BulkOrderbysea .el-date-editor--timerange.el-input,
.BulkOrderbysea .el-date-editor--timerange.el-input__inner {
  width: 68%;
}
.BulkOrderbysea .el-form-item,
.el-form-item--small.el-form-item {
  /* width: 20%; */
  display: inline-block;
  margin-right: 20px;
}
.BulkOrderbysea .el-button--primary {
  width: 128px;
  height: 36px;
  padding: 0;
  /* background: #FF4D01; */
  border-radius: 5px;
  border: none;
}
.BulkOrderbysea .el-tabs__header {
  margin: 0px 30px 15px;
}
.BulkOrderbysea .el-tabs__nav-wrap::after {
  background: none;
}
.BulkOrderbysea .el-table td,
.el-table th {
  text-align: center;
}
.BulkOrderbysea .el-tabs__item.is-active {
  color: #343434;
}
.BulkOrderbysea .el-tabs__item {
  color: #9a9a9a;
}
.BulkOrderbysea .el-table__body-wrapper {
  height: 530px !important;
}
/* table 滚动条 */
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar {
  width: 3px;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.BulkOrderbysea .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}

.helper {
  width: 100%;
  height: 15%;
  color: #FF4D01;
  align-content: center;
  text-align: center;
  font-size: 20px;
  margin-bottom: 20px;
}

/* .BulkOrderbysea .el-button--primary {
  width: 140px !important;
} */

.el-dialog__footer {
  text-align: center !important;
}

.center-box {
  width: 100%;
  height: 150px;
  position: relative;
  /* border: dashed 1px #d9d9d9; */
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin: -10px 0 20px;
}

/* .center-box:hover {
  border: dashed 1px #FF4D01;
} */

/deep/ .el-form-item{
  margin-bottom: 8px;
  line-height: 28px;
}

/deep/ .el-input__inner{
  height: 34px;
}

/deep/ .el-date-editor .el-range-separator {
  line-height: 28px;
}

/deep/ .el-date-editor .el-range__icon {
  line-height: 28px;
}

.tagBox {
  max-width: 300px;
  display: inline-block;
  height: 22px;
  text-overflow:ellipsis;
  white-space:nowrap;
  overflow:hidden;
  text-align: center;
  line-height: 24px;
  /* width:120px; */
}

</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FBAheader.vue